import { mode, StyleFunctionProps } from "@chakra-ui/theme-tools";

const Alert = {
  baseStyle: {
    container: {
      borderRadius: "8px",
    },
  },
  variants: {
    subtle: (props: StyleFunctionProps) => {
      if (props.colorScheme === "blue") {
        return {
          container: {
            bg: mode("primary.50", "#202325")(props),
          },
          description: {
            color: mode("primary.500", "white")(props),
          },
          icon: {
            color: mode("primary.500", "white")(props),
          },
        };
      }
    },
  },
};

export default Alert;
